import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { useDomain } from '../DomainContext';
import { sectionTabs } from '../siteNav';

/**
 * Sub-tabs at the top of a page inside a site's Growth or Settings section,
 * so Rankings / Offers / Products (or Site settings / Redirects / Directory)
 * are one click apart.
 *   <SiteSectionNav section="growth" />
 * `domain` overrides the header's selected domain (used to decide whether
 * the Directory tab shows) when the page already has fresher data.
 */
export default function SiteSectionNav({ section, domain }) {
  const { domainId } = useParams();
  const { pathname } = useLocation();
  const { selectedDomain } = useDomain();
  const d = domain || (selectedDomain && selectedDomain.id === domainId ? selectedDomain : null);
  const tabs = sectionTabs(section, domainId, d, pathname);
  if (tabs.length < 2) return null;
  return (
    <nav className="subnav" aria-label={section === 'growth' ? 'Growth' : 'Site settings'}>
      {tabs.map((t) => (
        <Link
          key={t.key}
          to={t.to}
          className={t.active ? 'active' : undefined}
          aria-current={t.active ? 'page' : undefined}
        >
          {t.label}
        </Link>
      ))}
    </nav>
  );
}
